document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll("[data-slider]");

  sliders.forEach((slider) => {
    const track = slider.querySelector(".slider-track");
    const slides = track.querySelectorAll(".slide");
    const prevBtn = slider.querySelector(".previ");
    const nextBtn = slider.querySelector(".nextup");
    const totalSlides = slides.length;
    let currentIndex = 0;

    const updateSlider = () => {
      const offset = currentIndex * -100;
      track.style.transform = `translateX(${offset}%)`;
    };

    prevBtn.addEventListener("click", () => {
      currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
      updateSlider();
    });

    nextBtn.addEventListener("click", () => {
      currentIndex = (currentIndex + 1) % totalSlides;
      updateSlider();
    });
  });
});
